const EndPoints = {
    AdminLogin: '/users/login/admin',
    ForgotPassword: '/verifications/forgot/password',
    ResetPassword: '/verifications/reset/',
    ViewCards: '/cards/all',
    AddCard: '/cards/add',
    AllCardList: '/cards/allCards',
    EditCard: '/cards/edit',
    CardInfo: '/cards/details',
    DeleteCards: '/cards/remove',
    ViewCardV2: '/cards/all/v2',
    ViewIssuerCardV2: '/cards/all/issuers/v2',

    DashboardGraph: '/dashboard/graph',
    DashboardDetails: '/dashboard/details',
    NewAccountsCount: '/dashboard/newAccounts',
    NewProfilesCount: '/dashboard/newProfiles',

    ProfileCardInfo: '/users/card/details',
    PendingCards: '/cards/pending',
    MergeRequests: '/cards/merge/request',
    SearchPendingCards: '/cards/pending/search/',
    ApproveCards: '/cards/approve',
    DeleteRequests: '/cards/request/remove',

    MessagesList: '/messages/all',
    MessagesReply: '/messages/reply',
    DeleteMessages: '/messages/remove',
    MessageDetails: '/messages/details',
    MessageToUser: '/messages/toUser',

    ManageAdmins: '/users/admin/all',
    AddAdmin: '/users/register/admin',
    EditAdmin: '/users/edit/admin',
    DeleteAdmins: '/users/remove',
    SuspendAdmins: '/users/change/admin/status',

    Accounts: '/users/all',
    DeleteAccounts: '/users/remove/accounts',
    SuspendAccounts: '/users/change/account/status',
    GetCSV: '/users/csv',

    Profiles: '/users/profiles/details',
    ProfileIssuerCards: '/profiles/cardlist',
    DeleteProfiles: '/profiles/remove',
    AddIssuer: '/issuers/add',
    EditIssuer: '/issuers/edit',
    DeleteIssuer: '/issuers/remove',
    GetIssuers: '/issuers/all',
    GetIssuerCards: '/issuers/cards',

    TopIssuers: '/dashboard/topissuers',
    IssuerColors: '/issuers/colors',
    Settings: '/users/edit/personal/data',
    GetRules: '/rules/all',

    GetCategories: '/pointcategories',
    UpdateCategories: '/pointcategories/update',

    UpdateSubcategories: '/pointcategories/updateSubcategories',
    GetSubcategories: '/pointcategories/details',
    GetCategoryById: '/pointcategories/categoryById',
    SavePointsCategory: '/pointcategories/addSingleCategory',
    AdminSaveSinglePointCategory: '/pointcategories/adminAddSingleCategory',

    ViewOffers: '/offers/all',
    AddOffer: '/offers/add',
    EditOffer: '/offers/edit',
    OfferInfo: '/offers/details',
    DeleteOffers: '/offers/remove',

    UpdateCheatSheet: '/cheatsheet/update',
    GetCheatSheet: '/cheatsheet',
    CheatSheetDetail: '/cheatsheet/getIssuer',
    UpdateRemovedCards: '/cheatsheet/updateCheatsheetRemovedCards',

    GetPromos: '/promo/getPromosAndHashtags',
    GetCardsAndPromos: '/promo/getCardsAndPromos',
    AddPromo: '/promo/add',
    GetAllPromos: '/promo/all',
    PromoDetail: '/promo/details',
    EditPromo: '/promo/edit',
    DeletePromo: '/promo/remove',
    PopulateCreditPerks: '/promo/populateCreditPerks',
    GetUserPromos: '/promo/userCreatedPromos',
    RemoveUserCreatedPromos: '/promo/removeUserCreatedPromos',

    GetBonusCategoryList: '/customBonusCategory/newBonusCategoryDetail',
    DeleteBonusCategory: '/customBonusCategory/adminDeleteCategory',
    EditCardBonusCategory: '/cards/CarddetailsBonusCategory',
    DenyBonusCategory: '/customBonusCategory/adminDenyCategory',
    ApproveBonusCategory: '/customBonusCategory/adminApproveCategory',
};

export default EndPoints;